<span>{{ params.value | customDate: 'mediumDate' : preferredLanguage }} </span>
@if (isExpiringSoon()) {
  <span class="expire-soon" [raUiBadge]="'value'" [badgeConfig]="badgeConfig"> Expiring Soon </span>
}
